import axios from 'axios';
import Cookies from 'js-cookie';

const state = {
  selectedBusiness: null
};

const mutations = {
  SET_SELECTED_BUSINESS(state, business) {
    state.selectedBusiness = business;
  }
};

const actions = {
  async createBusiness(_, businessData) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/businesses/create`,
        businessData,
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error creating business:', error);
      throw error;
    }
  },
  
  async getBusinessDetails({ commit }, businessId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/api/businesses/${businessId}/details`,
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      );
      
      commit('SET_SELECTED_BUSINESS', response.data.data);
      return response.data.data;
    } catch (error) {
      console.error('Error getting business details:', error);
      throw error;
    }
  },

  async addWorkerToBusiness(_, { businessId, workerId }) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/businesses/${businessId}/add-worker`,
        { workerId },
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      );
      return response.data.data;
    } catch (error) {
      console.error('Error adding worker to business:', error);
      throw error;
    }
  },

  async removeWorkerFromBusiness(_, { businessId, workerId }) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/businesses/${businessId}/remove-worker`,
        { workerId },
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      );
      return response.data.data;
    } catch (error) {
      console.error('Error removing worker from business:', error);
      throw error;
    }
  },

  async getBusinessRecipes(_, businessId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/api/recipes/business/${businessId}`,
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error getting business recipes:', error);
      throw error;
    }
  },

  async getBusinessEquipments({ rootState }) {
    try {
      // Verificar se temos o playerData com inventory
      const inventory = rootState.player.playerData?.inventory;
      
      if (!inventory) {
        throw new Error('Player inventory not found');
      }

      // Retornar os business_equipments do inventário do player
      const businessEquipments = inventory.business_equipments || [];
      
      // Log para debug
      console.log('Player business equipments:', businessEquipments);
      
      return businessEquipments;
    } catch (error) {
      console.error('Error getting business equipments:', error);
      throw error;
    }
  },

  async addEquipment(_, { businessId, equipmentId }) {
    try {
      // Check if the equipment is already installed in any business
      const response = await axios.put(
        `${process.env.VUE_APP_API_URL}/api/businesses/${businessId}/equipment`,
        { equipmentId },
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      );
      return response.data;
    } catch (error) {
      // Enhanced error handling to extract specific error messages
      if (error.response?.data?.error?.message === 'Equipment already installed in another business') {
        throw new Error('Este equipamento já está instalado em outro negócio.');
      } else if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      console.error('Error adding equipment:', error);
      throw error;
    }
  },

  async removeEquipment(_, { businessId, equipmentId }) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/businesses/${businessId}/unequip-equipment`,
        { equipmentId },
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error removing equipment:', error);
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  async createStoreItem(_, storeData) {
    try {
      if (!storeData.seller) {
        throw new Error('Seller ID (player) is required');
      }

      // Log para debug
      console.log('Debug - Creating store item:', {
        ...storeData,
        seller: storeData.seller // Confirmando que seller está presente
      });

      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/businesses/create-store`,
        storeData,
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      );

      console.log('Debug - Store creation response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating store item:', error);
      if (error.response) {
        console.error('Server Error Details:', error.response.data);
      }
      throw error;
    }
  },
  
  // Nova action para criar diretamente no item-store
  async createItemStoreRecord(_, itemStoreData) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/item-stores`,
        itemStoreData,
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      );
      
      console.log('Debug - Item store creation response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating item store record:', error);
      if (error.response) {
        console.error('Server Error Details:', error.response.data);
      }
      throw error;
    }
  },

  async createWorkerRest(_, { workerId, businessEquipmentId }) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/resting/worker/create`,
        { 
          workerId, 
          businessEquipmentId 
        },
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error creating worker rest:', error);
      throw error;
    }
  },
  
  async getActiveRests(_, businessId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/api/business/${businessId}/rests`,
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      );
      return response.data.data || [];
    } catch (error) {
      console.error('Error getting active rests:', error);
      return [];
    }
  },
  
  async getWorkersResting(_, workerIds) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/resting/workers`,
        { workerIds },
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      );
      return response.data.data || [];
    } catch (error) {
      console.error('Error getting workers resting records:', error);
      return [];
    }
  }
};

const getters = {
  selectedBusiness: state => state.selectedBusiness,
  availableWorkers: (state, getters, rootState) => {
    if (!rootState.player.playerData?.workers) return [];
    
    // Improved filter to check for workers without business or with different business
    return rootState.player.playerData.workers.filter(worker => {
      if (!worker.business) return true;
      // Convert to string for safe comparison
      const workerId = worker.business.id?.toString();
      const selectedId = state.selectedBusiness?.id?.toString();
      return !workerId || workerId !== selectedId;
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
